import {addCurrencySymbol, getTranslation, toggleLoader, handlePromise} from '../../lib';
import PaymentGatewayProcessor from './paymentGatewayProcessorAbstract';

export default class PaypalGateway extends PaymentGatewayProcessor {
  processCheckout() {
    return new Promise(async (resolve, reject) => {
      try {
        const recurlyTokenElement = document.querySelector('#recurly_token');

        const paypal = recurly.PayPal({
          locale: 'en_US',
          display: {
            displayName: `${getTranslation('total')}: ${addCurrencySymbol(total_price)}`,
          },
        });

        paypal.start();

        paypal.on('token', async token => {
          recurlyTokenElement.value = token.id;
          const [checkoutApiCallRes, checkoutApiCallErr] = await handlePromise(this.checkoutInit());

          if (checkoutApiCallErr) return reject(checkoutApiCallErr);

          resolve(checkoutApiCallRes);
        });

        paypal.on('error', err => {
          console.error('Paypal error', err);
          toggleLoader(false);
          reject(err);
        });

        paypal.on('cancel', err => {
          toggleLoader(false);
        });
      } catch (err) {
        throw reject(err);
      }
    });
  }
}
